import { fetchAdapter } from "./fetch-adapter";
export default fetchAdapter;
